import { Skeleton } from "@/components/ui/skeleton";

// Paragraphs of line widths per fake message body — real emails read as a
// few short paragraphs, not one solid block.
const MESSAGE_PARAGRAPHS = [
  [
    ["w-11/12", "w-full", "w-10/12", "w-full"],
    ["w-9/12", "w-full", "w-11/12"],
    ["w-10/12", "w-full", "w-8/12"],
  ],
  [
    ["w-10/12", "w-full", "w-11/12"],
    ["w-full", "w-9/12", "w-full"],
    ["w-10/12", "w-7/12"],
  ],
  [
    ["w-full", "w-10/12", "w-11/12"],
    ["w-9/12", "w-6/12"],
  ],
];

/**
 * Mirrors the loaded inbox inside the white panel: the Subject block, then
 * divide-y message blocks (avatar, from/to lines, sent date, prose lines) —
 * same geometry as CreatorInbox + InboxMessage. The real toolbar and
 * breadcrumbs render on the frame while loading (they only need creator
 * data), so this fakes nothing outside the panel.
 */
export function CreatorInboxSkeleton() {
  return (
    <>
      <div className="py-2 px-3 flex flex-col gap-1 border-b border-dashed">
        <Skeleton className="w-14 h-3" />
        <Skeleton className="w-96 max-w-full h-4" />
      </div>
      <div className="divide-y">
        {MESSAGE_PARAGRAPHS.map((paragraphs, i) => (
          <div key={i} className="p-5 pb-10">
            <div className="flex flex-row items-start">
              <Skeleton className="size-10 rounded-pill shrink-0 mr-5" />
              <div className="flex w-full justify-between">
                <div className="flex flex-col gap-1.5">
                  <Skeleton className="h-4 w-44" />
                  <Skeleton className="h-3 w-56" />
                </div>
                <Skeleton className="h-3 w-16 mt-1" />
              </div>
            </div>
            <div className="ml-15 mt-4 max-w-xl space-y-10">
              {paragraphs.map((lines, j) => (
                <div key={j} className="space-y-3">
                  {lines.map((width, k) => (
                    <Skeleton key={k} className={`h-4 ${width}`} />
                  ))}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
